import { computed } from "vue";
import * as allIcons from "ionicons/icons";
export default {
  props: {
    icon: {
      type: String,
      default: ""
    }
  },

  setup(props) {
    const iconSvg = computed(() => allIcons[props.icon] ? allIcons[props.icon].split(",")[1].replace(/<title>([\S\s]*?)<\/title>/, "") : "");
    return {
      iconSvg
    };
  }

};